/** @jsxRuntime classic */
import React from 'react';
import { mdx } from '@mdx-js/react'
/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Llegó el momento de aprender como agregar estilos a nuestro componente dependiendo del estado.`}</p>
    <p>{`Dentro de la Pokédex nuestro objetivo es que una de las luces esté parpadeando cuando estemos cargando un nuevo Pokémon sin embargo podríamos lograr cientos de efectos y animaciones aplicando este concepto.`}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;